module.exports = __webpack_public_path__ + "img/mdi_facebook.e3a67f36.svg";